import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 24px 24px 154px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Header = styled.div`
  margin-bottom: 32px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 24px 0;
  width: 100%;
  text-align: center;
`;

export const BlocksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 800px;
`;

export const Controls = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  background: ${props => props.switcher ? '#404040' : '#f9fafb'};
  border-radius: 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  width: 100%;
`;

export const ControlsLeft = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`;

export const ControlsRight = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 150px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.switcher ? '#d1d5db' : '#6b7280'};
`;

export const Select = styled.select`
  padding: 10px 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#d1d5db'};
  border-radius: 8px;
  background: ${props => props.switcher ? '#2d2d2d' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &:hover {
    border-color: ${props => props.switcher ? '#6b7280' : '#9ca3af'};
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 120px;

  &:hover {
    background: #5a67d8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CreateButton = styled.button`
  padding: 10px 20px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 140px;

  &:hover {
    background: #059669;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

export const GroupsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;
  justify-items: center;
`;

export const GroupCard = styled.div`
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: ${props => props.switcher ? '#6b7280' : '#d1d5db'};
  }
`;

export const GroupName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 12px 0;
`;

export const GroupInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const GroupStat = styled.div`
  text-align: center;
  padding: 8px;
  background: ${props => props.switcher ? '#2d2d2d' : '#f9fafb'};
  border-radius: 6px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
`;

export const StatValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 2px;
`;

export const StatLabel = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
`;

export const LoadingText = styled.div`
  font-size: 16px;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  background: ${props => props.switcher ? '#2d2d2d' : '#fef2f2'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#fecaca'};
  border-radius: 8px;
  margin: 20px 0;
`;

export const ErrorText = styled.div`
  font-size: 14px;
  color: ${props => props.switcher ? '#fca5a5' : '#dc2626'};
  text-align: center;
`;

// Адаптивность для мобильных устройств
export const ResponsiveContainer = styled(Container)`
  @media (max-width: 768px) {
    padding: 16px;
    margin: 0 auto;
    align-items: center;
  }
`;

export const ResponsiveControls = styled(Controls)`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ResponsiveGroupsContainer = styled(GroupsContainer)`
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    justify-items: center;
  }
`;

// Модальное окно
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: ${props => (props.switcher ? '#1f2937' : '#ffffff')};
  padding: 24px;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  background: ${props => props.switcher ? '#2d2d2d' : '#f9fafb'};
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    color: ${props => props.switcher ? '#ffffff' : '#111827'};
    background: ${props => props.switcher ? '#525252' : '#f3f4f6'};
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
`;

export const GroupDetailsContainer = styled.div`
  display: grid;
  gap: 16px;
`;

export const DetailSection = styled.div`
  background: ${props => props.switcher ? '#2d2d2d' : '#f9fafb'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  border-radius: 6px;
  padding: 16px;
`;

export const DetailTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 12px 0;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #667eea;
`;

export const DetailLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const AddAgentsButton = styled.button`
  padding: 10px 20px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 16px;
  width: 100%;

  &:hover {
    background: #059669;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

// Стили для второго модального окна
export const SecondModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

export const SecondModalContent = styled.div`
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  border-radius: 8px;
  padding: 0;
  max-width: 700px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
`;

export const SearchSection = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
`;

export const SearchTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 16px 0;
`;

export const SearchForm = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  padding: 10px 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#d1d5db'};
  border-radius: 6px;
  background: ${props => props.switcher ? '#2d2d2d' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-size: 14px;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  }
`;

export const SearchButton = styled.button`
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #5a67d8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

export const AgentsListSection = styled.div`
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
`;

export const AgentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: ${props => props.switcher ? '#2d2d2d' : '#f9fafb'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.switcher ? '#404040' : '#ffffff'};
    border-color: ${props => props.switcher ? '#6b7280' : '#d1d5db'};
  }
`;

export const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AgentName = styled.span`
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-weight: 600;
  font-size: 14px;
`;

export const AgentLcid = styled.span`
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  font-size: 12px;
`;

export const AddAgentButton = styled.button`
  padding: 6px 12px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #059669;
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;

// Стили для блока автоматизации
export const AutomationSection = styled.div`
  background: ${props => props.switcher ? '#404040' : '#f9fafb'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
`;

export const AutomationTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 16px 0;
`;

export const AutomationContent = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const FlagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FlagLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.switcher ? '#d1d5db' : '#6b7280'};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FlagCheckbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #667eea;
  cursor: pointer;
`;

export const ApplyAutomationButton = styled.button`
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 120px;

  &:hover {
    background: #5a67d8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

// Стили для модального окна создания группы
export const CreateGroupForm = styled.div`
  display: grid;
  gap: 16px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.switcher ? '#d1d5db' : '#6b7280'};
`;

export const FormInput = styled.input`
  padding: 10px 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#d1d5db'};
  border-radius: 6px;
  background: ${props => props.switcher ? '#2d2d2d' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-size: 14px;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  }
`;

export const FormTextarea = styled.textarea`
  padding: 10px 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#d1d5db'};
  border-radius: 6px;
  background: ${props => props.switcher ? '#2d2d2d' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  background: ${props => props.switcher ? '#525252' : '#f3f4f6'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  border: 1px solid ${props => props.switcher ? '#6b7280' : '#d1d5db'};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.switcher ? '#6b7280' : '#e5e7eb'};
  }
`;

export const SubmitButton = styled.button`
  padding: 10px 20px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #059669;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

export const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 20px;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  font-size: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

export const DailyStatisticsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-top: 16px;
`;

export const DailyStatCard = styled.div`
  background: ${props => (props.switcher ? '#374151' : '#f3f4f6')};
  border: 1px solid ${props => (props.switcher ? '#4b5563' : '#e5e7eb')};
  border-radius: 8px;
  padding: 12px;
  text-align: center;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const DayNumber = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${props => (props.switcher ? '#d1d5db' : '#374151')};
  margin-bottom: 4px;
`;

export const CheckedChats = styled.div`
  font-size: 14px;
  color: ${props => (props.switcher ? '#9ca3af' : '#6b7280')};
`; 